import * as React from "react"
import {
  Facebook,
  MessageSquare,
  Twitter,
  Linkedin,
  Link2,
} from "react-feather"
import styled from "styled-components"
import { useStaticQuery, graphql } from "gatsby"

const data = [
  {
    icon: <Facebook className="ambila-bantu-icon" size={30} />,
    url: "https://www.facebook.com/sharer.php?u=",
  },
  {
    icon: <MessageSquare className="ambila-bantu-icon" size={30} />,
    url: "https://api.whatsapp.com/send?text=",
  },
  {
    icon: <Twitter className="ambila-bantu-icon" size={30} />,
    url: "https://twitter.com/intent/tweet?url=&text=&via=",
  },
  {
    icon: <Linkedin className="ambila-bantu-icon" size={30} />,
    url: "https://www.linkedin.com/sharing/share-offsite/?url=",
  },
  {
    icon: <Link2 className="ambila-bantu-icon" size={30} />,
    placeholder: "link",
  },
]

const Share = ({ url, style }) => {
  const {
    site: {
      siteMetadata: { siteUrl },
    },
  } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            siteUrl
          }
        }
      }
    `
  )

  return (
    <CardFooter style={style}>
      <div>
        <p>Partager</p>
        <Ul url={url}>
          {data.map((link, i) => {
            return (
              <li key={i}>
                {link.placeholder === "link" ? (
                  <span
                    style={{ cursor: "pointer" }}
                    aria-hidden="true"
                    className="ambila-bantu"
                    title="Copier le lien"
                    onClick={() =>
                      navigator.clipboard.writeText(`${siteUrl}${url}`)
                    }
                  >
                    {link.icon}
                  </span>
                ) : (
                  <a
                    href={`${link.url}${siteUrl}${url}`}
                    className="ambila-bantu"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {link.icon}
                  </a>
                )}
              </li>
            )
          })}
        </Ul>
      </div>
    </CardFooter>
  )
}

export default Share

const CardFooter = styled.div`
  div {
    padding: 0 1rem;
    display: flex;
    align-items: center;
    background: var(--clr-grey-9);
    p {
      margin-top: 0;
    }
  }
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1rem 0;
  p {
    margin-bottom: 0;
    font-weight: bold;
    color: var(--clr-grey-5);
  }
  p:first-of-type {
    display: inline-block;
    margin-right: 0.5rem;
    text-transform: uppercase;
    letter-spacing: 2px;
    font-size: 0.85rem;
  }

  @media (max-width: ${(props) => props.theme.screen.xs}) {
    display: block;
    align-items: center;
    text-align: center;

    div {
      display: block;
      padding-top: 0.5rem;
      padding-bottom: 0.1rem;
    }
  }
`

const Ul = styled.ul`
  column-gap: 1rem;
  display: flex;
  align-items: center;
  a,
  span {
    display: flex;
  }

  li {
    list-style: none;
  }
  .ambila-bantu {
    font-size: 1.75rem;
    color: var(--clr-grey-1);
    // transition: var(--transition);
    &:hover {
      color: var(--clr-primary-5);
    }
  }
`
